import type { HTMLAttributes } from 'react';
import TopNavDashes from '../TopNavDashes';
import QuestionMarkdown from '../QuestionMarkdown/QuestionMarkdown';

interface TopTextBlockProps
  extends Omit<HTMLAttributes<HTMLDivElement>, 'content'> {
  title: string;
  content?: string[];
  /** Markdown question text. Rendered via snarkdown instead of bullets. */
  markdown?: string | string[];
}

export default function TopTextBlock({
  title,
  content,
  markdown,
  className = '',
  ...restProps
}: TopTextBlockProps) {
  return (
    <div
      {...restProps}
      className={`relative z-[100] flex w-full max-w-[336px] flex-col gap-5 ${className}`}
    >
      <TopNavDashes />
      <div
        className="flex w-full flex-col rounded-[10px] bg-white px-7 pt-3 pb-4"
        style={{ boxShadow: '0px 4px 4px 0px #3B3D5A40' }}
      >
        <p className="text-center text-lg font-bold">{title}</p>
        {markdown ? (
          <QuestionMarkdown text={markdown} className="mt-[7px]" />
        ) : (
          content && (
            <div className="top-text-block-bullets mt-[7px] flex">
              <ul>
                {content?.map((text, index) => (
                  <li key={`${index}-${text}`}>{text}</li>
                ))}
              </ul>
            </div>
          )
        )}
      </div>
    </div>
  );
}
